export default {
    //home24 main
  "Welcome": "Bienvenue",


  // Home24Open component translations
  'Events': 'Événements',
  'Running': 'En cours',
  'Opened': 'Ouvert',
  'All Events': 'Tous les événements',
  
  // Home24Timeleft component translations
  'minute | minutes': 'minute | minutes',
  'hour | hours': 'heure | heures',
  'Buy extra hours': 'Acheter des heures',
  
  // Home24Storage component translations
  'Media Storage': 'Stockage média',
  
  // Home24Plan component translations
  'Free': 'Gratuit',
  'Expired': 'Expiré',
  'All content will be deleted the': 'Tout le contenu sera supprimé le',
  'renew': 'renouveler',
  'Upgrade': 'Changer d’offre',
  
  // Home24News component translations
  'Delete news': 'Supprimer l\'actualité',
  'Are you sure you want to delete news': 'Êtes-vous sûr de vouloir supprimer l\'actualité',
  'Yes': 'Oui',
  'No': 'Non',
  'Add/Edit news': 'Ajouter/Modifier l\'actualité',
  'Close': 'Fermer',
  'Save': 'Enregistrer',
  'Edit': 'Modifier',
  'Delete': 'Supprimer',
  'Add': 'Ajouter',
  'Done': 'Terminé',
  
  // Home24Create component translations
  'New Event': 'Nouvel événement',

  // Home24StorageCleanModal component translations
  "Don't forget to download the records you want to keep.": "N'oubliez pas de télécharger les enregistrements que vous souhaitez conserver."
}